import React, { useState, useEffect } from 'react'
import './mapview-style.scss'
import { useLocation } from 'react-router-dom'
import usePlantMapViewStyles from './styles.js'

const PlantMapView = () => {
  const classes = usePlantMapViewStyles()
  const { state } = useLocation()
  const [currentLocation, setCurrentLocation] = useState(null)

  useEffect(() => {
    if (state?.latitude && state?.longitude) {
      setCurrentLocation({
        lat: parseFloat(state.longitude), // Swap here
        lng: parseFloat(state.latitude), // Swap here
      })
    } else {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            setCurrentLocation({
              lat: position.coords.latitude,
              lng: position.coords.longitude,
            })
          },
          (error) => {
            console.error('Error getting location:', error)
            setCurrentLocation({ lat: 10.8505, lng: 76.2711 })
          }
        )
      } else {
        setCurrentLocation({ lat: 10.8505, lng: 76.2711 })
      }
    }
  }, [state])

  if (!currentLocation) {
    return <div>Loading map...</div>
  }

  return (
    <div className={classes.root} id="plantmapview">
      <div className="align_btw mb_10">
        <div>
          <div className="mapview_list_h">
            <div className="h_txt1">{state?.plantName || 'Plant Location'}</div>
            <div className="h_txt2">
              {state?.projectCode || 'Location Details'}
            </div>
          </div>
        </div>
      </div>
      <hr className="brdr_btm" />
      <div>
        <div>
          <iframe
            src={`https://www.google.com/maps/embed/v1/place?key=AIzaSyDELXYU2T40qihoAZJyr4q0ti-Vui1FUsQ&q=${currentLocation.lat},${currentLocation.lng}&zoom=15`}
            width="100%"
            height="400"
            frameBorder="0"
            style={{ border: 0 }}
            allowFullScreen=""
            aria-hidden="false"
            tabIndex="0"
          ></iframe>
        </div>
      </div>
      <div className="mt-3 text-sm text-gray-600">
        Current Location: {currentLocation.lat.toFixed(4)},{' '}
        {currentLocation.lng.toFixed(4)}
      </div>
    </div>
  )
}

export default PlantMapView
